import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinusIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.6665 10H16.3332",
		stroke: "currentColor",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMinusIcon;
